import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Event registration service
export const handleRegister = async (eventData) => {
    try {
        console.log('handleRegister - Received eventData:', eventData); // Debug log

        const requestBody = {
            event_type: eventData.eventType || 'webinar',
            event_name: eventData.eventTitle || 'Mindful Living Webinar',
            user_id: eventData.userId.toString(),
            status: 'registered'
        };

        console.log('handleRegister - Request body:', requestBody); // Debug log

        const response = await api.post('/events', requestBody);

        return {
            success: true,
            data: response.data,
            message: response.data.message || 'Successfully enrolled!'
        };
    } catch (error) {
        // Handle different types of errors
        if (error.response) {
            // Server responded with error status
            const { status, data } = error.response;

            if (status === 409 || (data.error && data.error.includes('Duplicate entry'))) {
                return {
                    success: true,
                    isAlreadyEnrolled: true,
                    message: 'Already enrolled in this event'
                };
            }

            return {
                success: false,
                error: data.error || data.message || 'Registration failed',
                status
            };
        } else if (error.request) {
            // Network error
            return {
                success: false,
                error: 'Network error. Please check your connection.',
                isNetworkError: true
            };
        } else {
            // Other error
            return {
                success: false,
                error: error.message || 'An unexpected error occurred'
            };
        }
    }
};

// Check enrollment status service
export const checkEnrollmentStatus = async (eventType, userId) => {
    try {
        const response = await api.get('/events/check-status', {
            params: {
                eventType: eventType || 'webinar',
                userId: userId
            }
        });

        return {
            success: true,
            isEnrolled: !!response.data.isEnrolled,
            event: response.data.event || null
        };
    } catch (error) {
        console.error('Error checking enrollment status:', error);
        return {
            success: false,
            isEnrolled: false,
            error: error.response?.data?.error || 'Failed to check enrollment status'
        };
    }
};

// Get events service
export const getEvents = async (filters = {}) => {
    try {
        const response = await api.get('/events', {
            params: {
                type: filters.eventType,
                status: filters.status
            }
        });

        return {
            success: true,
            events: response.data || []
        };
    } catch (error) {
        console.error('Error fetching events:', error);
        return {
            success: false,
            events: [],
            error: error.response?.data?.error || 'Failed to fetch events'
        };
    }
};

export default {
    handleRegister,
    checkEnrollmentStatus,
    getEvents
};

export const getYogaVideoForToday = async (videoId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/signed-url?trackId=${videoId}&content=yoga-video`
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching yoga video:`, error);
        throw error.response?.data || { message: "Failed to fetch video" };
    }
};

export const getSmartBiometricSound = async (trackId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/signed-url?trackId=${trackId}&content=sound-therapy`
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching sound therapy music:`, error);
        throw error.response?.data || { message: "Failed to fetch sound therapy music" };
    }
};

export const getPodcastForToday = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/podcast`
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching podcast:`, error);
        throw error.response?.data || { message: "Failed to fetch podcast" };
    }
};